// #12993 — Ask AI (support assistant) monthly question allowance.
//
// The finite limit key an operator may set on the tenant's `assistant`
// entitlement `limits` (the audited admin override) and its default. Shared by
// modules/tenants (apply-route validation), modules/assistant (enforcement)
// and apps/admin (the override editor).
//
// Same policy as the AI Insights allowance (../insights/ai-allowance.ts):
// there is NO representation of "unlimited" -- every override is an integer
// 1..10000, and an absent key means the default.
import { INSIGHTS_LIMIT_MAX, INSIGHTS_LIMIT_MIN, isValidInsightsLimitValue, } from '../insights/ai-allowance.js';
export const ASSISTANT_LIMIT_KEYS = {
    question: 'assistant_monthly_questions',
};
export const ASSISTANT_ALLOWANCE_DEFAULTS = {
    question: 100,
};
/**
 * The monthly Ask AI question cap to enforce: a valid finite override, else the
 * default. An invalid or missing override never widens the cap.
 */
export function effectiveAssistantMonthlyCap(override) {
    return isValidInsightsLimitValue(override) ? override : ASSISTANT_ALLOWANCE_DEFAULTS.question;
}
const KNOWN_KEYS = new Set(Object.values(ASSISTANT_LIMIT_KEYS));
/** Problems with a proposed `limits` object for module `assistant`; [] means valid. */
export function validateAssistantLimits(limits) {
    const problems = [];
    for (const [key, value] of Object.entries(limits)) {
        if (!KNOWN_KEYS.has(key)) {
            problems.push(`unknown assistant limit key: ${key}`);
        }
        else if (!isValidInsightsLimitValue(value)) {
            problems.push(`${key} must be an integer from ${INSIGHTS_LIMIT_MIN} to ${INSIGHTS_LIMIT_MAX}`);
        }
    }
    return problems;
}
//# sourceMappingURL=ai-allowance.js.map